import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { JBMPlantSelectorComponent } from './JBMPlantSelector/JBMPlantSelector.component';

@NgModule({
  declarations: [
    JBMPlantSelectorComponent
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    JBMPlantSelectorComponent
  ]
})
export class JBMSelectsModule { }
